var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1737 16.0069L9.93911 2.77227C9.54989 2.38305 9.54989 1.75201 9.93911 1.3628C10.3302 0.97174 10.9649 0.973872 11.3533 1.36755L25.0876 15.2877C25.4798 15.6852 25.4799 16.3242 25.0877 16.7218L11.3532 30.646C10.9649 31.0398 10.3301 31.042 9.93906 30.6509C9.54987 30.2617 9.54987 29.6307 9.93906 29.2415L23.1737 16.0069Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightL);
export default __webpack_public_path__ + "static/media/chevron-right-L.d634575da722dcbf133687d3ebfe0d4a.svg";
export { ForwardRef as ReactComponent };